import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import uid from 'utils/uid';
import pathWithRewrite from 'utils/pathWithRewrite';
import {
  Wrapper,
  SiteContainer,
  Flex,
  Aside,
  Main,
} from 'core/layout';
import {
  BreadcrumbsConnected,
  Button,
  Checkbox,
  Heading,
  Paragraph,
} from 'elements';
import { PaginationNav } from 'elements/Pagination';
import tulkojumi from 'utils/tulkojumi';

import {
  ListHeading,
  StyledList,
  FilterLabel,
} from 'pages/Rezultati/styled';
import {
  StyledItem,
  StyledHeading,
  TagsList,
} from 'pages/Rezultati/components/RezultatsItem/styled';

import {
  FlexGroup,
  FiltersList,
  StyledDescription,
} from './styled';


const POSTS_PER_PAGE = 10;

const ALL_POST_TYPES = [
  'Aktuali',
  'Dokumenti',
  'Dome',
  'Iepirkumi',
  'LiepajniekiemPost',
  'Page',
  'PasvaldibasKontakti',
  'Post',
  'Projekti',
  'UznemejiemPost',
  'Video'
];

// FIXME: Šobrīd nav iespējams nosaukt vienādi atšķirīgus filtrus,
// jo ties piesaistīti GraphQL pieprasījumam un datiem ar filtrēšanas loģiku:
// - jāpārveido, lai filtrs varētu saturēt masīvu ar post_type
/* const _mapPostTypeToName = (postType, teksti) => {
  switch (postType) {
    case 'LiepajniekiemPost':
    case 'UznemejiemPost':
    case 'Dome':
    case 'Page':
      return tulkojumi(teksti, 'raksti');
    case 'Post':
    case 'Aktuali':
    case 'Video':
      return tulkojumi(teksti, 'jaunumi');
    case 'Dokumenti':
      return tulkojumi(teksti, 'dokumenti');
    case 'Iepirkumi':
      return tulkojumi(teksti, 'iepirkumi');
    case 'PasvaldibasKontakti':
      return tulkojumi(teksti, 'kontakti');
    case 'Projekti':
      return tulkojumi(teksti, 'pilsetas_attistibas_projekti');
    default:
      return postType;
  }
} */
const _mapPostTypeToName = (postType, teksti) => {
  switch (postType) {
    case 'LiepajniekiemPost':
      return tulkojumi(teksti, 'liepajniekiem');
    case 'UznemejiemPost':
      return tulkojumi(teksti, 'uznemejiem');
    case 'Dome':
      return tulkojumi(teksti, 'dome');
    case 'Page':
      return tulkojumi(teksti, 'raksti');
    case 'Post':
      return tulkojumi(teksti, 'jaunumi');
    case 'Aktuali':
      return tulkojumi(teksti, 'aktuali');
    case 'Video':
      return tulkojumi(teksti, 'video');
    case 'Dokumenti':
      return tulkojumi(teksti, 'dokumenti');
    case 'Iepirkumi':
      return tulkojumi(teksti, 'iepirkumi');
    case 'PasvaldibasKontakti':
      return tulkojumi(teksti, 'kontakti');
    case 'Projekti':
      return tulkojumi(teksti, 'pilsetas_attistibas_projekti');
    case 'NodokluZinojumi':
      return tulkojumi(teksti, 'nodoklu_zinojumi')
    default:
      return postType;
  }
}


const SearchQuery = gql`
  query SearchQuery($lang: String!, $text: String!, $page: Int, $perpage: Int, $postTypes: [String]) {

    search(lang: $lang, text: $text, page: $page, perpage: $perpage, post_type: $postTypes) {
      total
      post_type
      all_post_types {
        name
        count
      }
      posts {
        path
        title
        post_type
        description_tag
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }

    teksti(lang: $lang, _id: [
      "meklesanas_rezultati",
      "rezultati",
      "rezultats",
      "veids",
      "dome",
      "video",
      "raksti",
      "jaunumi",
      "aktuali",
      "dokumenti",
      "iepirkumi",
      "projekti",
      "kontakti",
      "uznemejiem",
      "liepajniekiem",
      "pilsetas_attistibas_projekti",
      "no",
      "talak",
      "atpakal",
      "meklejot",
      "nekas_netika_atrasts",
      "meklet_citu",
      "nodoklu_zinojumi"
    ]) {
      _id
      text
    }
  }
`;


class Mekletajs extends React.PureComponent {
  _renderFilterItem = (filter) => {
    const id = uid();

    const {
      filterState,
      onFilterSelect,
      data: {
        search,
        teksti,
      },
    } = this.props;

    const filteredPostTypes = search.all_post_types;

    return (
      <li key={id}>
        <Checkbox
          id={id}
          disabled={filter.count === 0}
          checked={filter.selected}
          onChange={(event) => {
            event.preventDefault();
            onFilterSelect && onFilterSelect(filter.name, !filter.selected, filteredPostTypes);
          }}
        />
        <label htmlFor={id}>
          { _mapPostTypeToName(filter.name, teksti) }
          {
            (typeof filter.count === 'number') && (
              <span>
                {` (${filter.count})`}
              </span>
            )
          }
        </label>
      </li>
    );
  }

  _trimText = (text, maxLength = 150, alwaysWithEllipsis = false, minLength = 50) => {
    let trimmedText;
    if (text.length > maxLength) {
      trimmedText = text.substr(0, maxLength)
        .replace(/(\s+)$/g, '');
      return `${trimmedText}…`;
    } else if (alwaysWithEllipsis && text.length > minLength) {
      trimmedText = text.substr(0, text.length - 2)
        .replace(/(\s+)$/g, '');
      return `${trimmedText}…`;
    } else {
      return text;
    }
  }

  render() {
    const {
      input,
      lang,
      pathname,
      filterState,
      onFilterSelect,
      onPaginate,
      data: {
        loading,
        search,
        teksti,
      },
    } = this.props;

    if (loading) {
      return null;
    }

    const vsk = String(search.total).substr(-1) === '1';
    const rezultatiTeksts = vsk ?
      tulkojumi(teksti, 'rezultats') :
      tulkojumi(teksti, 'rezultati');

    const pagesTotal = Math.ceil(search.total / POSTS_PER_PAGE);
    const getPageButtonLabel = (targetPage) => (
      `${targetPage} ${tulkojumi(teksti, 'no')} ${pagesTotal}`
    );

    const prevPageButton = (filterState.page > 0) && {
      label: getPageButtonLabel(filterState.page),
      onClick: (event) => {
        event.preventDefault();
        onPaginate && onPaginate(filterState.page - 1)
      },
    };

    const nextPageButton = (filterState.page < pagesTotal - 1) && {
      label: getPageButtonLabel(filterState.page + 2),
      onClick: (event) => {
        event.preventDefault();
        onPaginate && onPaginate(filterState.page + 1)
      }
    };

    const filtersArray = filterState.allPostTypes || search.all_post_types;

    return (
      <SiteContainer>

        <BreadcrumbsConnected
          lang={lang}
          path={pathname}
        />

        <Wrapper>
          <Heading>
            {
              search.total > 0 ?
                `${tulkojumi(teksti, 'meklesanas_rezultati')} “${input}”` :
                `${tulkojumi(teksti, 'meklejot')} “${input}” ${tulkojumi(teksti, 'nekas_netika_atrasts')}`
            }
          </Heading>

          {
            search.total > 0 ? (
              <FlexGroup>
                <Aside>
                  <FilterLabel>
                    {tulkojumi(teksti, 'veids')}
                  </FilterLabel>
                  <FiltersList>
                    {
                      filtersArray.map((filter) => {
                        const filterWithSelected = Object.assign({}, filter, {
                          selected: (filterState.postTypes && filterState.postTypes.includes(filter.name)) || false,
                        });
                        return this._renderFilterItem(filterWithSelected);
                      })
                    }
                  </FiltersList>
                </Aside>

                <Main>
                  <ListHeading>
                    <span>
                      {search.total}&nbsp;
                </span>
                    {rezultatiTeksts}
                  </ListHeading>
                  <StyledList>
                    {
                      search.posts.map((post, i) => {
                        const rewrite = pathWithRewrite(post);
                        let LinkComponent;
                        let rewriteProps;
                        if (rewrite.location.startsWith('http')) {
                          LinkComponent = 'a';
                          rewriteProps = {
                            href: rewrite.location,
                            target: rewrite.target,
                          };
                        } else {
                          LinkComponent = Link;
                          rewriteProps = {
                            to: {
                              pathname: rewrite.location,
                              state: {
                                searchInput: input,
                              },
                            },

                          };
                        }
                        return (
                          <StyledItem key={i}>
                            <LinkComponent {...rewriteProps}>
                              <StyledHeading>
                                {post.title}
                              </StyledHeading>
                              {
                                post.description_tag && (
                                  <StyledDescription>
                                    {this._trimText(post.description_tag, 150, true)}
                                  </StyledDescription>
                                )
                              }
                              <TagsList>
                                {_mapPostTypeToName(post.post_type, teksti)}
                              </TagsList>
                            </LinkComponent>
                          </StyledItem>
                        );
                      })
                    }
                  </StyledList>
                  <PaginationNav
                    prev={prevPageButton}
                    next={nextPageButton}
                    teksti={teksti}
                  />
                </Main>
              </FlexGroup>
            ) : (
                <Button label={tulkojumi(teksti, 'meklet_citu')} accent='secondary' data-query-id='js-search-button' />
            )
          }
        </Wrapper>

      </SiteContainer>
    );
  }
}

const MekletajsWithData = graphql(SearchQuery, {
  options: ({ lang, input, filterState }) => ({
    variables: {
      lang: lang || 'lv',
      text: input,
      page: filterState.page,
      perpage: POSTS_PER_PAGE,
      postTypes: filterState.postTypes,
    }
  }),
})(Mekletajs);

export default MekletajsWithData;



// WEBPACK FOOTER //
// ./src/pages/Mekletajs/Mekletajs.jsx